"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PdfRef = void 0;
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
/**
 * The `PdfRef` defines a reference to an PDF
 *
 * The reference is usually used to create an REST API call by igus Integration Framework in order
 * to download a PDF file like an IA-Zeichnung
 */
class PdfRef {
    get id() {
        return this.model.Id;
    }
    set id(v) {
        this.model.Id = v;
    }
    constructor(model) {
        this.model = model;
    }
    static fromJson(model) {
        return new PdfRef((0, echain_shared_ts_utils_1.clonePrimitive)(model));
    }
    static fromModel(model) {
        return new PdfRef(model);
    }
    fromJson(json) {
        if (json.Id != null)
            this.id = json.Id;
    }
    fromModel(model) {
        this.model = model;
    }
    toJson() {
        return {
            Id: this.id,
        };
    }
    toModel() {
        return this.model;
    }
    clone() {
        return PdfRef.fromJson(this.toJson());
    }
}
exports.PdfRef = PdfRef;
//# sourceMappingURL=PdfRef.js.map